import { commonConstants as cc } from 'srcReact/components'
import { alertActions } from 'srcReact/Alert'
import {
  generalService,
  userService,
  subscriptionService,
  groupService,
  authenticationService
} from 'srcReact/services'
import { redirectToPage } from 'srcReact/helpers/history'
import { isNativeAndroid, isNativeIOS } from 'srcReact/helpers/utils'
import { appConstantSettings } from 'srcReact/appConstantSettings'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY

export const commonActions = {
  getTimezoneByLatLong,
  clearTimezone,
  submitFormLanding,
  setIsMobile,
  setIsTablet,
  openPopin,
  closePopin,
  getSubscription,
  getManagePaymentUrl,
  cancelSubscription,
  fileCreation,
  complexFilesCreation,
  startStopFileProcessing,
  clearFileIds,
  fileCreationRemove,
  searchInterest,
  suggestInterest,
  updateInterestsAfterSelection,
  updateSelectedInterests,
  getCurrencyList,
  getLanguages,
  getAllGroupsByOrgId,
  setPopupCookie,
  getPopupCookie,
  setUserLocation,
  getUserLocation,
  checkNativeUserAppVersion,
  clearNotificationsCount,
  getUserIPAddress,
  addUserPageView,
  updateBannerData,
  closeBannerData,
  getTagUsers,
  setUserAppVersion,
  getMembersToTransferGroup,
  setTransferRoleData,
  getAppStoreVersions,
  // getExternalAPIConnection,
  // saveExternalAPIToken,
  setIsNative,
  setIsDesktop,
  updateGDPR,
  getGDPR,
  getTimezones,
  setTimezone,
  displayCTA,
  closeCTA,
  openCTA
}

function updateBannerData(data) {
  return {
    type: cc.UPDATE_BANNER_DATA,
    bannerData: data
  }
}

function closeBannerData(id) {
  return {
    type: cc.CLOSE_BANNER_DATA,
    bannerId: id
  }
}

function clearNotificationsCount() {
  return {
    type: cc.CLEAR_NOTIFICATION_COUNT
  }
}

function getTimezoneByLatLong(latitude, longitude) {
  return (dispatch) => {
    dispatch(request(latitude, longitude))
    const timestamp = new Date().getTime() / 1000
    generalService.getTimezoneByLatLong(latitude, longitude, timestamp).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_TIMEZONE_BY_LAT_LONG_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_TIMEZONE_BY_LAT_LONG_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_TIMEZONE_BY_LAT_LONG_FAILURE, error }
  }
}
function clearTimezone() {
  return { type: cc.CLEAR_TIMEZONE }
}

function setIsMobile(status) {
  return { type: cc.SET_IS_MOBILE, status }
}

function setIsTablet(status) {
  return { type: cc.SET_IS_TABLET, status }
}

function setIsNative(status) {
  return { type: cc.SET_IS_NATIVE, status }
}

function setIsDesktop(status) {
  return { type: cc.SET_IS_DESKTOP, status }
}

function openPopin(name) {
  return { type: cc.POPIN_OPEN, name }
}

function closePopin() {
  return { type: cc.POPIN_CLOSE }
}

function submitFormLanding(form) {
  return (dispatch) => {
    dispatch(request(form))

    userService.submitFormLanding(form).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error))
      }
    )
  }

  function request(form) {
    return { type: cc.LANDING_FORM_REQUEST, form }
  }
  function success(response) {
    return { type: cc.LANDING_FORM_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.LANDING_FORM_FAILURE, error }
  }
}

function getSubscription(organizationId, fromChargebee = false, redirectUrl) {
  return (dispatch) => {
    dispatch(request(organizationId))

    subscriptionService.getSubscription(organizationId, fromChargebee).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
        if (redirectUrl) {
          redirectToPage(redirectUrl)
        }
      }
    )
  }

  function request(organizationId) {
    return { type: cc.GET_SUBSCRIPTION_REQUEST, organizationId }
  }
  function success(response) {
    return { type: cc.GET_SUBSCRIPTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_SUBSCRIPTION_FAILURE, error }
  }
}

function getManagePaymentUrl(organizationId) {
  return (dispatch) => {
    dispatch(request(organizationId))

    subscriptionService.getManagePaymentUrl(organizationId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(organizationId) {
    return { type: cc.GET_PAYMENTMANAGEURL_REQUEST, organizationId }
  }
  function success(response) {
    return { type: cc.GET_PAYMENTMANAGEURL_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_PAYMENTMANAGEURL_FAILURE, error }
  }
}

function cancelSubscription(organizationId) {
  return (dispatch) => {
    dispatch(request(organizationId))

    subscriptionService.cancel(organizationId).then(
      (response) => {
        dispatch(success(response))
        commonActions.getSubscription(organizationId)
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(organizationId) {
    return { type: cc.CANCEL_SUBSCRIPTION_REQUEST, organizationId }
  }
  function success(response) {
    return { type: cc.CANCEL_SUBSCRIPTION_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.CANCEL_SUBSCRIPTION_FAILURE, error }
  }
}

//fileCreation is used to upload the files without using imagekit. It directly uploads the file on s3
//whereas filesCreation function is used for complex uploding using imagekit
function fileCreation(files, params = {}, fromFileId) {
  return (dispatch) => {
    dispatch(request({ files, params, fromFileId }))
    if (params.organization_id > 0 && params.is_logged === 0) {
      if (params.apiSubdomain && params.apiSubDomain?.length > 0) {
        createFile(dispatch, params, params.apiSubDomain)
      } else {
        authenticationService.getApiSubdomain(params.organization_id).then((response) => {
          const { apiSubdomain } = response
          if (apiSubdomain) {
            createFile(dispatch, params, null, apiSubdomain)
          }
        })
      }
    } else {
      createFile(dispatch, params, fromFileId)
    }
  }

  function createFile(dispatch, params, fromFileId = 0, apiSubDomain = '') {
    let promise = null
    if (fromFileId > 0) {
      promise = generalService.filesCreationWithFileId(fromFileId)
    } else {
      promise = generalService.filesCreation(files, { ...params, apiSubDomain })
    }
    promise.then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error && error.message))
      }
    )
  }

  function request(datas) {
    return { type: cc.FILES_CREATION_REQUEST, datas }
  }
  function success(response) {
    return { type: cc.FILES_CREATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.FILES_CREATION_FAILURE, error }
  }
}

function startStopFileProcessing(mode, objectId) {
  return {
    type: cc.START_FILE_PROCESSING,
    mode,
    objectId
  }
}

function complexFilesCreation(files, messageTag, isLogged, mediaType, startingWithCount = 1, is_draft = 0) {
  return (dispatch) => {
    // dispatch(request(files, params))
    generalService.filesCreationWithTag(files, messageTag, isLogged, mediaType, startingWithCount).then(
      (response) => {
        response['is_draft'] = is_draft
        //  dispatch(success(response))
      },
      (error) => {
        // dispatch(failure(error))
        dispatch(alertActions.error(error && error.message))
      }
    )
  }
  //  function request(files, params) {
  //    return { type: cc.FILES_CREATION_REQUEST, params, fileCount: files.length, from }
  //  }
  //  function success(response) {
  //    return { type: cc.FILES_CREATION_SUCCESS, response }
  //  }
  //  function failure(error) {
  //    return { type: cc.FILES_CREATION_FAILURE, error }
  //  }
}

function clearFileIds(objectId) {
  return { type: cc.CLEAR_FILE_IDS, objectId }
}

function fileCreationRemove() {
  return (dispatch) => {
    dispatch({ type: cc.FILE_CREATION_REMOVE })
  }
}

function searchInterest(interestType, search, offset, interestIds, isLogged = 0) {
  return (dispatch) => {
    dispatch(request({ interestType, search, offset }))

    generalService.searchInterest(interestType, search, offset, interestIds, isLogged).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: cc.SEARCH_INTEREST_REQUEST, data }
  }
  function success(response) {
    return { type: cc.SEARCH_INTEREST_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.SEARCH_INTEREST_FAILURE, error }
  }
}

function suggestInterest(type, name, origin, orgId, userEmail, entityId, is_logged = 0) {
  return (dispatch) => {
    dispatch(request({ name, is_logged }))

    generalService.suggestInterest(type, name, origin, orgId, userEmail, entityId, is_logged).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: cc.SUGGEST_INTEREST_REQUEST, datas }
  }
  function success(response) {
    return { type: cc.SUGGEST_INTEREST_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.SUGGEST_INTEREST_FAILURE, error }
  }
}

function updateInterestsAfterSelection(interest, actionType) {
  return {
    type: cc.UPDATE_INTETESTS_AFTER_SELECTION,
    interest,
    actionType
  }
}
function updateSelectedInterests(interests) {
  return {
    type: cc.UPDATE_SELECTED_INTERESTS,
    interests
  }
}

function getCurrencyList(is_logged) {
  return (dispatch) => {
    dispatch(request(is_logged))

    generalService.getCurrencyList(is_logged).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_CURRENCIES_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_CURRENCIES_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_CURRENCIES_FAILURE, error }
  }
}

function getLanguages(is_logged, env = 'all') {
  return (dispatch) => {
    dispatch(request(is_logged))

    generalService.getLanguages(is_logged, env).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_LANGUAGES_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_LANGUAGES_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_LANGUAGES_FAILURE, error }
  }
}

function getAllGroupsByOrgId(organizationId, scope = '') {
  return (dispatch) => {
    dispatch(request(organizationId))

    generalService.getAllGroupsByOrgId(organizationId, scope).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_GROUPS_BY_ORGID_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_GROUPS_BY_ORGID_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_GROUPS_BY_ORGID_FAILURE, error }
  }
}

function setPopupCookie(name) {
  return (dispatch) => {
    dispatch(request(name))

    generalService.setPopupCookie(name).then(
      (response) => {
        dispatch(success(response, name))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.SET_POPUP_COOKIE_REQUEST, response }
  }
  function success(response, popupName) {
    return { type: cc.SET_POPUP_COOKIE_SUCCESS, response, popupName }
  }
  function failure(error) {
    return { type: cc.SET_POPUP_COOKIE_FAILURE, error }
  }
}

function getPopupCookie(name) {
  return (dispatch) => {
    dispatch(request(name))

    generalService.getPopupCookie(name).then(
      (response) => {
        dispatch(success(response, name))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_POPUP_COOKIE_REQUEST, response }
  }
  function success(response, popupName) {
    return { type: cc.GET_POPUP_COOKIE_SUCCESS, response, popupName }
  }
  function failure(error) {
    return { type: cc.GET_POPUP_COOKIE_FAILURE, error }
  }
}

function setUserLocation(location) {
  return { type: cc.SET_USER_LOCATION, location }
}

function getUserIPAddress() {
  return (dispatch) => {
    dispatch(request())

    generalService.getUserIPAddress().then(
      (response) => {
        // Flatten and normalize timezone data if present
        if (response.timezone) {
          const { timeZoneId, UTCOffset, timeZoneName, timeZoneAbbreviation } = response.timezone

          response.timezone = timeZoneId || response.timezone
          response.utc_offset = UTCOffset || ''
          response.timezone_name = timeZoneName || ''
          response.timezone_abbreviation = timeZoneAbbreviation || ''
        }
        response['with_chosen_location'] = 1
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_USER_LOCATION_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_USER_LOCATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_USER_LOCATION_FAILURE, error }
  }
}

function addUserPageView(page, id_object) {
  return (dispatch) => {
    dispatch(request(page, id_object))

    generalService.addUserPageView(page, id_object).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.ADD_USER_PAGEVIEW_REQUEST, response }
  }
  function success(response) {
    return { type: cc.ADD_USER_PAGEVIEW_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.ADD_USER_PAGEVIEW_FAILURE, error }
  }
}

function getUserLocation() {
  return (dispatch) => {
    dispatch(request())

    generalService.getUserLocation().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_USER_LOCATION_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_USER_LOCATION_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_USER_LOCATION_FAILURE, error }
  }
}

function getTagUsers(type, id, search = '', offset = 0, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request(type, id, search, offset, quantity))

    generalService.getTagUsers(type, id, search, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_TAG_USERS_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_TAG_USERS_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_TAG_USERS_FAILURE, error }
  }
}

function setUserAppVersion(version) {
  return { type: cc.SET_USER_APP_VERSION, version }
}
function checkNativeUserAppVersion(userAppVersion) {
  return () => {
    generalService.getAppStoreVersions().then(async (response) => {
      if (isNativeIOS() && userAppVersion < response.data.ios) {
        redirectToPage('/0/how-update-native-application')
      } else if (isNativeAndroid() && userAppVersion < response.data.android) {
        redirectToPage('/0/how-update-native-application')
      }
    })
  }
}
function getAppStoreVersions() {
  return (dispatch) => {
    dispatch(request())

    generalService.getAppStoreVersions().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: cc.GET_APP_STORE_VERSIONS_REQUEST, data }
  }
  function success(data) {
    return { type: cc.GET_APP_STORE_VERSIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: cc.GET_APP_STORE_VERSIONS_FAILURE, error }
  }
}

function getMembersToTransferGroup(
  groupId,
  pagination,
  search = '',
  role,
  quantity = appConstantSettings.PAGINATION_QUANTITY
) {
  const { nextOffset, isPagination } = pagination
  return (dispatch) => {
    dispatch(request({ groupId, isPagination, search }))

    generalService.getMembersToTransferGroup(groupId, role, nextOffset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_MEMBERS_TO_TRANSFER_GROUP_REQUEST, response }
  }
  function success(response) {
    let users = [...response[1].users]
    if (response[0] && response[0].users) {
      users = [...response[0].users, ...users]
    }
    const updatedResponse = { users: users, stats: response[1].stats, isPagination, search }
    return { type: cc.GET_MEMBERS_TO_TRANSFER_GROUP_SUCCESS, updatedResponse }
  }
  function failure(error) {
    return { type: cc.GET_MEMBERS_TO_TRANSFER_GROUP_FAILURE, error }
  }
}

function setTransferRoleData(data) {
  return { type: cc.SET_TRANSFER_ROLE_DATA, data }
}

function updateGDPR(performace, functional, marketing) {
  return (dispatch) => {
    dispatch(request({ performace, functional, marketing }))

    generalService.updateGDPR(performace, functional, marketing).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.UPDATE_GDPR_REQUEST, response }
  }
  function success(response) {
    return { type: cc.UPDATE_GDPR_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.UPDATE_GDPR_FAILURE, error }
  }
}
function getGDPR() {
  return (dispatch) => {
    dispatch(request())

    generalService.getGDPR().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_GDPR_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_GDPR_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_GDPR_FAILURE, error }
  }
}

function getTimezones() {
  return (dispatch) => {
    dispatch(request())

    generalService.getTimezones().then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.GET_TIMEZONES_REQUEST, response }
  }
  function success(response) {
    return { type: cc.GET_TIMEZONES_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.GET_TIMEZONES_FAILURE, error }
  }
}

function displayCTA(ctaCategory, entityId = 0) {
  return (dispatch) => {
    dispatch(request({ ctaCategory, entityId }))

    userService.displayCTA(ctaCategory, entityId).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.DISPLAY_CTA_REQUEST, response }
  }
  function success(response) {
    return { type: cc.DISPLAY_CTA_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.DISPLAY_CTA_FAILURE, error }
  }
}

function closeCTA(ctaCategory) {
  return (dispatch) => {
    dispatch(request())

    userService.closeCTA(ctaCategory).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.CLOSE_CTA_REQUEST, response }
  }
  function success(response) {
    return { type: cc.CLOSE_CTA_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.CLOSE_CTA_FAILURE, error }
  }
}

function openCTA(ctaCategory, ctaType) {
  return (dispatch) => {
    dispatch(request())

    userService.openCTA(ctaCategory, ctaType).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: cc.OPEN_CTA_REQUEST, response }
  }
  function success(response) {
    return { type: cc.OPEN_CTA_SUCCESS, response }
  }
  function failure(error) {
    return { type: cc.OPEN_CTA_FAILURE, error }
  }
}

function setTimezone(timezone) {
  return { type: cc.SET_TIMEZONE, timezone }
}
